// Page Dashboard (Jalon 1 — version minimaliste, sera enrichie au Jalon 4).
// Affiche l'utilisateur connecté + bouton de déconnexion.

import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Footer } from '../components/shared/Footer';

export const Dashboard = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isSuperAdmin = user?.role === 'SUPER_ADMIN';

  const onLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-neutral-900">Falko</h1>
          <div className="flex items-center gap-3 text-sm">
            {isSuperAdmin && (
              <Link
                to="/admin"
                className="inline-flex items-center gap-1.5 text-violet-700 bg-violet-50 hover:bg-violet-100 px-3 py-1.5 rounded-lg transition"
              >
                <span aria-hidden>👑</span> Back-office
              </Link>
            )}
            <button
              onClick={onLogout}
              className="text-neutral-600 hover:text-neutral-900 px-3 py-1.5 rounded-lg hover:bg-neutral-100 transition"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-8">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-2xl">🎉</span>
            <h2 className="text-2xl font-semibold text-neutral-900">Bienvenue !</h2>
          </div>
          <p className="text-neutral-600 mb-6">Tu es maintenant connectée à Falko.</p>
          <dl className="space-y-3 text-sm">
            <div className="flex gap-3">
              <dt className="w-28 text-neutral-500">Email</dt>
              <dd className="text-neutral-900 font-medium">{user?.email}</dd>
            </div>
            <div className="flex gap-3">
              <dt className="w-28 text-neutral-500">Rôle</dt>
              <dd className="text-neutral-900 font-medium">{user?.role}</dd>
            </div>
            <div className="flex gap-3">
              <dt className="w-28 text-neutral-500">Tenant ID</dt>
              <dd className="text-neutral-900 font-mono text-xs">{user?.tenantId}</dd>
            </div>
          </dl>
        </div>
        <div className="mt-6 bg-gradient-to-br from-purple-50 to-pink-50 border border-purple-200 rounded-2xl p-6">
          <div className="flex items-start gap-3 mb-3">
            <span className="text-2xl">📷</span>
            <div>
              <h3 className="font-semibold text-neutral-900 mb-1">Connecte ton compte Instagram</h3>
              <p className="text-sm text-neutral-600">
                Pour que Falko commence à surveiller tes commentaires et te suggérer des réponses
                dans ta voix de marque.
              </p>
            </div>
          </div>
          <Link
            to="/instagram"
            className="inline-flex items-center gap-2 bg-white border border-purple-300 hover:bg-purple-100 text-purple-700 px-4 py-2 rounded-lg font-medium text-sm transition"
          >
            Gérer mes comptes Instagram →
          </Link>
        </div>
        <div className="mt-6 bg-white rounded-2xl shadow-sm border border-neutral-200 p-6">
          <div className="flex items-start gap-3 mb-3">
            <span className="text-2xl">💬</span>
            <div>
              <h3 className="font-semibold text-neutral-900 mb-1">Commentaires à traiter</h3>
              <p className="text-sm text-neutral-600">
                Vois les commentaires reçus, l'analyse de Falko et ses suggestions de réponse dans ta voix.
              </p>
            </div>
          </div>
          <Link
            to="/comments"
            className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg font-medium text-sm transition"
          >
            Voir mes commentaires →
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};
